import { Check, ArrowUp } from "lucide-react";

const footerLinks = {
  Product: [
    { label: "How It Works", href: "#how-it-works" },
    { label: "Security", href: "#security" },
    { label: "Pricing", href: "#pricing" },
  ],
  Legal: [
    { label: "Privacy Policy", href: "#" },
    { label: "Terms of Service", href: "#" },
    { label: "Cookie Policy", href: "#" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-bg-primary relative">
      {/* Top gradient line */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-accent-purple/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
          {/* Brand — takes 5 cols (wider) */}
          <div className="lg:col-span-5">
            <a href="#" className="flex items-center gap-2 mb-4">
              <img src="/logo.png" alt="HirenFire" className="h-10 w-auto" />
              <span className="text-lg font-display font-bold tracking-tight">
                <span className="text-white">HIREN</span>
                <span className="text-gradient-bold">FIRE</span>
              </span>
            </a>
            <p className="text-sm text-gray-500 mb-6 max-w-sm">
              The privacy-first, crypto-native hiring platform for OFM teams, VAs, and chatters. Built with crypto.
            </p>
            <a
              href="#cta"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-none rounded-br-xl rounded-tr-xl bg-gradient-warm text-white text-sm font-display font-semibold hover:opacity-90 transition-opacity"
            >
              Join the Waitlist
              <ArrowUp size={14} />
            </a>
          </div>

          {/* Links — 2 cols each */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title} className="lg:col-span-2">
              <h4 className="text-xs font-mono uppercase tracking-widest text-gray-500 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Why HirenFire — 3 cols */}
          <div className="lg:col-span-3">
            <h4 className="text-xs font-mono uppercase tracking-widest text-gray-500 mb-4">Why HirenFire?</h4>
            <ul className="space-y-2.5">
              {[
                "Crypto escrow payments",
                "Anonymous until paid",
                "Phone-verified users",
                "Encrypted private chat",
                "10% flat fee",
              ].map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm text-gray-400">
                  <Check size={12} className="text-green-500 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between pt-8 border-t border-surface-border/30 gap-4">
          <div className="flex items-center gap-3">
            <p className="text-xs text-gray-600">
              &copy; {new Date().getFullYear()} HirenFire
            </p>
            <span className="text-gray-700">·</span>
            <p className="text-xs text-gray-600 font-mono">
              Built with crypto
            </p>
          </div>
          <div className="flex items-center gap-5">
            {["Twitter", "Discord", "Telegram"].map((platform) => (
              <a
                key={platform}
                href="#"
                className="text-xs text-gray-600 hover:text-gray-300 transition-colors font-mono uppercase tracking-wider"
              >
                {platform}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
